export default "__VITE_ASSET__BJv31PDd__"